import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.replace";

var manufacturerLogoUrl = function manufacturerLogoUrl(manufacturer, width) {
  return "https://manufacturer-logos.papertrail.io/" + manufacturer.toLowerCase().replace(' ', '-') + "-" + width + "w.png";
};

export default manufacturerLogoUrl;